// Auto-extracted from LangContext.jsx — single source of truth for AR translations.
// Edit this file to update wording. Keys must stay in sync across active locales (see ACTIVE_LANGS).
/* eslint-disable */
const dict = {
  app_tagline: 'مستقبل كتيبات لعب كرة السلة',
  nav_dashboard: 'لوحة التحكم', nav_playbook: 'كتاب اللعب', nav_editor: 'المحرر', nav_roster: 'القائمة',
  nav_ai: 'مدرب الذكاء', nav_live: 'مباراة مباشرة', nav_simulator: 'محاكي', nav_academy: 'أكاديمية',
  nav_invitations: 'دعوات', nav_admin: 'المسؤول', nav_pricing: 'الباقات',
  nav_marketplace: 'المتجر', nav_profile: 'ملفي', nav_notifications: 'الإشعارات', nav_achievements: 'الإنجازات',
  nav_tactile: 'لمسي', mob_market: 'السوق', mob_ia: 'ذكاء',
  login: 'دخول', register: 'تسجيل', logout: 'خروج', email: 'البريد', password: 'كلمة المرور',
  name: 'الاسم', role: 'الدور', coach: 'مدرب', player: 'لاعب', or: 'أو',
  welcome_back: 'مرحبا بعودتك', create_account: 'إنشاء حساب',
  plays: 'خطط', total_plays: 'إجمالي الخطط', active_players: 'لاعبون نشطون',
  success_rate: 'معدل النجاح', ai_sessions: 'جلسات الذكاء',
  search: 'بحث...', all_categories: 'كل الفئات',
  cat_man: 'ضد رجل', cat_zone: 'ضد منطقة', cat_ato: 'ATO', cat_blob: 'BLOB', cat_slob: 'SLOB', cat_endgame: 'نهاية المباراة',
  create_play: 'إنشاء خطة', save: 'حفظ', cancel: 'إلغاء', edit: 'تعديل', delete: 'حذف',
  upload_photo: 'رفع صورة', add_player: 'إضافة لاعب',
  height: 'الطول', weight: 'الوزن', number: 'الرقم', position: 'المركز',
  dominant_hand: 'اليد المسيطرة', strength: 'القوة', weakness: 'الضعف', ideal_role: 'الدور المثالي',
  generate_link: 'توليد رابط دعوة', copy_link: 'نسخ', copied: 'تم النسخ',
  chat_placeholder: 'اسأل الذكاء الاصطناعي...',
  send: 'إرسال', generate_play: 'توليد خطة', recommend_plays: 'توصية',
  predict_success: 'توقع',
  defense: 'الدفاع', moment: 'اللحظة', recommend: 'توصية',
  step: 'خطوة', steps: 'خطوات', play: 'تشغيل', stop: 'إيقاف',
  pause: 'إيقاف مؤقت', prev: 'السابق', next: 'التالي', loop_label: 'تكرار', off_label: 'إيقاف',
  worked: '✔ نجح', didnt_work: '✕ لم ينجح',
  coach_premium: 'كوتش بريميوم', player_premium: 'لاعب بريميوم', academy: 'أكاديمية',
  month: 'شهر', subscribe: 'اشترك',
  hello: 'مرحبا', loading: 'جار التحميل...', view_all: 'عرض الكل', back: 'رجوع', close: 'إغلاق', confirm: 'تأكيد',
  language: 'اللغة', settings: 'الإعدادات', not_found: 'غير موجود',
  top_plays: 'أفضل الخطط حسب معدل النجاح', distribution: 'التوزيع', open_ai_coach: 'فتح مدرب الذكاء',
  my_roster: 'قائمتي', my_publications: 'منشوراتي', no_plays_yet: 'لم تنشئ خططك الخاصة بعد',
  no_invitations_yet: 'لم تولد دعوات بعد', go_to: 'انتقل إلى', go_to_editor: 'انتقل إلى المحرر',
  dashboard_subtitle: 'لوحة تحكم فريقك', greeting_morning: 'صباح الخير',
  privacy_policy: 'سياسة الخصوصية', terms_of_service: 'شروط الخدمة',
  error_generic: 'خطأ', invalid_credentials: 'بيانات الاعتماد غير صالحة',
  have_account: 'لديك حساب بالفعل؟', no_account: 'ليس لديك حساب؟',
  invites_subtitle: 'روابط قصيرة بنطاقك مع تحليلات النقرات والاشتراكات.',
  invite_label: 'الوسم', invite_label_placeholder: 'الفريق الرئيسي',
  invite_custom_slug: 'رابط مختصر مخصص (اختياري)',
  voice: 'صوت', muted: 'كتم',
  voice_on_hint: 'الراوي مفعّل (انقر لكتمه)',
  voice_off_hint: 'تشغيل الراوي الصوتي',
  loop_on_hint: 'التكرار مفعّل',
  loop_off_hint: 'التكرار متوقف',
  translating: 'جارٍ الترجمة...',
  show_as: 'عرض كـ:', photo: 'صورة', initials: 'الأحرف الأولى',
  description_label: 'الوصف', works_against: 'يعمل ضد',
  listen_narration: 'الاستماع للسرد', tactical_simulator: 'محاكي تكتيكي',
  ai_prediction: 'توقع الذكاء', export_share: 'تصدير ومشاركة',
  image_label: 'صورة', share_whatsapp_btn: 'مشاركة عبر واتساب', generating_dots: 'جارٍ الإنشاء…',
  delete_confirm: 'حذف هذه الخطة؟', deleted: 'تم الحذف',
  pdf_generated: 'تم إنشاء PDF', image_downloaded: 'تم تنزيل الصورة',
  frames_not_ready: 'اللقطات غير جاهزة، حاول مجددًا',
  share_error: 'خطأ في المشاركة', image_export_error: 'خطأ في تصدير الصورة',
  pdf_export_error: 'خطأ في تصدير PDF', prediction_error: 'خطأ في توقع الذكاء',
  feedback_success_yes: 'تم وضع علامة ناجح', feedback_success_no: 'تم وضع علامة فشل',
  feedback_error: 'خطأ في الملاحظات', translation_error: 'خطأ في الترجمة',
  cached_translation: 'ترجمة مخزنة', translated_by_ai: 'تمت الترجمة بالذكاء',
  translated_to: 'تمت الترجمة إلى', translate_with_ai: 'ترجمة بالذكاء',
  whatsapp_open_attach: 'تم فتح واتساب: أرفق الصورة التي تم تنزيلها',
  reviews_title: 'المراجعات', your_review: 'مراجعتك', publish_review: 'نشر المراجعة',
  update_review: 'تحديث',
  review_placeholder: 'اختياري: أخبر المدربين الآخرين بما تعتقد...',
  only_buyers_review: 'يمكن للمدربين الذين اشتروا فقط المراجعة.',
  no_reviews_yet: 'لا توجد مراجعات بعد. كن الأول.',
  choose_star: 'اختر نجمة واحدة على الأقل', review_sent: 'تم إرسال المراجعة',
  must_buy_review: 'يجب شراء هذه الخطة لمراجعتها',
  review_singular: 'مراجعة', review_plural: 'مراجعات',
  editor_title: 'محرر الخطط الاحترافي',
  editor_subtitle: 'متوافق مع القلم اللمسي والإصبع والفأرة. اختر "قلم حر" للرسم.',
  blank_board: 'لوحة فارغة', templates: 'قوالب', preview_label: 'معاينة',
  play_name: 'الاسم', play_description: 'الوصف',
  category: 'الفئة', difficulty: 'الصعوبة',
  beginner: 'مبتدئ', intermediate: 'متوسط', advanced: 'متقدم',
  pencil_free: 'قلم حر',
  add_offense: '+هجوم', add_defense: '+دفاع',
  steps_title: 'الخطوات', add_step: 'إضافة', step_description: 'وصف الخطوة',
  speed: 'السرعة', delay_exit: '⏱ تأخير الخروج',
  assign_player_circle: 'تعيين لاعب للدائرة',
  quick_player_selection: 'اختيار سريع للاعبين',
  animation_preview: 'معاينة بالحركة',
  load_template_title: 'تحميل قالب',
  export_pdf_title: 'تصدير إلى PDF',
  export_png_title: 'تنزيل كصورة',
  share_whatsapp_title: 'مشاركة عبر واتساب',
  clear_text: 'مسح', unassigned: 'غير معيّن',
  double_click_assign: 'النقر المزدوج على دائرة يفتح هذا المحدد. ستظهر الصورة + الرقم + الاسم على الرمز.',
  route_timing: 'توقيت المسارات',
  route_timing_desc: 'السرعة والتأخير لكل لاعب لتنسيق pick&roll و back-door والشاشة المزدوجة…',
  my_roster_quick: 'قائمتي — لمسة سريعة',
  players_count: 'لاعبين',
  no_roster_yet_label: 'لا يوجد لاعبون بعد. أضف في',
  no_roster_yet_label_after: 'للاختيار السريع.',
  quick_add_hint: 'انقر لاعبًا ليظهر فورًا. انقر مزدوجًا على دائرة لإعادة التعيين.',
  on_court_badge: 'في الملعب', tips_label: 'نصائح',
  tip_offense_defense_a: 'انقر الملعب لإضافة دائرة عامة.',
  tip_pencil_a: 'ارسم',
  tip_pencil_b: 'مسار اللاعب',
  tip_pencil_c: 'بدءًا من دائرته وسيضيف النظام الخطوة التالية. المنحنيات الحرة تبقى كملاحظة.',
  tip_double_tap: 'انقر مزدوجًا على أي دائرة لإعادة تعيينها للاعب من القائمة.',
  no_name: 'بلا اسم', my_new_play: 'خطتي الجديدة', step_default_desc: 'خطوة',
  move_players: 'تحريك اللاعبين', arrow_move: 'سهم الحركة',
  pass_tool: 'تمريرة', dribble_tool: 'مراوغة', screen_tool: 'شاشة', eraser_tool: 'ممحاة',
  saved_ok: 'تم الحفظ', save_error_msg: 'خطأ في الحفظ',
  ai_hero_title: 'مرحبًا، أنا مدربك الذكي',
  ai_hero_subtitle: 'اطلب مني خططًا أو تحسينات أو توقعات أو استراتيجيات.',
  ai_powered_by: 'مدعوم بـ PlayMaster IA',
  ai_quick_1_label: 'أنشئ خطة ضد منطقة 2-3',
  ai_quick_2_label: 'أوصِ بخطط ATO ضد دفاع رجل لرجل',
  ai_quick_3_label: 'حسّن Horns Flare',
  ai_quick_1_prompt: 'صمم خطة جديدة لمهاجمة دفاع منطقة 2-3. اشرح الخطوات الثلاث الرئيسية ولماذا تعمل.',
  ai_quick_2_prompt: 'أوصِ بأفضل 3 خطط ATO (بعد الوقت المستقطع) ضد دفاع رجل لرجل. برر.',
  ai_quick_3_prompt: 'لدي خطة Horns Flare. كيف يمكنني تحسين الانتشار وزوايا الشاشة لجعلها أكثر فتكًا ضد التبديلات؟',
  ai_connection_error: 'خطأ اتصال الذكاء',
  academy_title: 'أكاديمية',
  academy_subtitle: 'مفاهيم تكتيكية وقراءة لعبة وأساسيات. انقر درسًا لمشاهدة دروس YouTube المختارة.',
  academy_will_open_youtube: 'سنفتح YouTube بدروس مختارة حول هذا الموضوع.',
  academy_watch_youtube: 'شاهد الدروس على YouTube',
  academy_coming_soon: 'قريبًا: دروس أصلية مسجلة من قبل مدربين نخبة.',
  academy_lesson_1_title: 'الانتشار: كيفية فتح الملعب',
  academy_lesson_2_title: 'كيفية مهاجمة منطقة 2-3',
  academy_lesson_3_title: 'الدفاع ضد Pick & Roll: drop coverage مقابل switch',
  academy_lesson_4_title: 'قراءة المباراة: متى تغير الإيقاع',
  academy_lesson_5_title: 'تنفيذ Horns Action',
  academy_lesson_6_title: 'BLOB و SLOB في اللحظات الحاسمة',
  academy_cat_fundamentals: 'أساسيات',
  academy_cat_vs_zone: 'ضد المنطقة',
  academy_cat_defense: 'دفاع',
  academy_cat_iq: 'ذكاء كرة السلة',
  academy_cat_systems: 'أنظمة',
  academy_cat_ato_blob: 'ATO/BLOB',
  pricing_h1: 'ارفع مستوى لعبتك', pricing_subtitle: 'اختر الخطة التي تناسب تدريبك.',
  plan_most_popular: 'الأكثر شعبية', payments_mocked: 'MOCKED · سيتم دمج المدفوعات مع Stripe في الإصدار القادم.',
  feat_playbook_full: 'كتاب لعب كامل (100 خطة)',
  feat_advanced_editor: 'محرر متقدم',
  feat_unlimited_roster: 'قائمة لاعبين غير محدودة',
  feat_50_ai: '50 جلسة ذكاء/شهر',
  feat_unlimited_invites: 'دعوات غير محدودة',
  feat_global_plays: 'الوصول للخطط العالمية',
  feat_didactic_photos: 'عرض تعليمي بصورك',
  feat_personal_ai_coach: 'مدرب ذكي شخصي',
  feat_individual_stats: 'إحصاءات فردية',
  feat_academy_mode: 'وضع الأكاديمية',
  feat_100_players: 'حتى 100 لاعب',
  feat_multi_coach: 'متعدد المدربين',
  feat_unlimited_ai: 'ذكاء غير محدود',
  feat_personal_branding: 'علامة تجارية شخصية',
  feat_priority_support: 'دعم بأولوية',
  live_h1: 'وضع المباراة المباشرة',
  live_subtitle: 'اختر دفاع الخصم واللحظة؛ يوصي الذكاء بـ 3 خطط.',
  live_voice_on: 'الصوت مفعّل — وضع المباراة', live_voice_off: 'تشغيل الراوي الصوتي',
  live_voice_extra: 'ستُقرأ كل خطة بصوت عالٍ خطوة بخطوة.',
  live_defense_label: 'الدفاع:', live_moment_label: 'اللحظة:',
  live_justification: 'تبرير الذكاء', live_see_detail: 'عرض التفاصيل',
  def_man: 'ضد رجل', def_zone_2_3: 'ضد منطقة 2-3', def_zone_3_2: 'ضد منطقة 3-2',
  def_zone_1_3_1: 'ضد منطقة 1-3-1', def_switch: 'ضد Switch', def_press: 'ضد Press',
  moment_half_court: 'نصف الملعب', moment_ato: 'بعد الوقت المستقطع (ATO)',
  moment_blob: 'BLOB (خط القاعدة)', moment_slob: 'SLOB (خط الجانب)', moment_endgame: 'نهاية المباراة',
  marketplace_seller_blurb: 'تحتفظ بـ 85% من كل عملية بيع. السعر: 0.99$ – 99.99$.',
  profile_eyebrow: 'الملف', profile_h1: 'ملف المدرب الخاص بي',
  elite_verified_badge: 'مدرب نخبة موثّق', identity_section: 'الهوية',
  no_photo: 'بدون صورة', upload_photo_btn: 'رفع صورة',
  photo_help: 'صورتك ومؤهلاتك هي أول ما سيراه المشترون. كن محترفًا.',
  field_display_name: 'الاسم العلني', field_team: 'الفريق', field_country: 'البلد',
  field_credentials: 'المؤهلات (مثلاً: مدرب أول · 10 سنوات · دوري ACB)',
  field_twitter: 'تويتر / X (@المستخدم)', field_instagram: 'إنستغرام (@المستخدم)',
  field_website: 'الموقع', field_bio: 'السيرة (أخبر المجتمع أي نوع من المدربين أنت)',
  save_profile_btn: 'حفظ الملف', elite_status: 'حالة النخبة',
  verified_state: 'موثّق',
  elite_active_text: 'حسابك نخبة. خططك مرئية في المتجر.',
  elite_since: 'منذ:', view_my_store: 'عرض متجري',
  not_elite_yet: 'لست بعد مدرب نخبة. اطلب التحقق لبيع الخطط في المتجر.',
  requirements_label: 'المتطلبات:',
  req_bio_photo: 'سيرة + صورة احترافية', req_credentials: 'مؤهلات قابلة للتحقق',
  req_5_plays: 'الحد الأدنى 5 خطط ذاتية',
  request_verification: 'طلب التحقق (للمسؤول فقط في v1)',
  my_achievements: 'إنجازاتي', no_achievements: 'لم تفتح أي إنجازات بعد.',
  publish_in_marketplace: 'نشر في المتجر',
  unpublish_from_marketplace: 'إزالة من المتجر',
  photo_uploaded: 'تم رفع الصورة', upload_error: 'خطأ في الرفع',
  profile_saved: 'تم حفظ الملف', play_published: 'تم نشر الخطة في المتجر',
  play_unpublished: 'تم إزالتها من المتجر',
  price_prompt: 'السعر (USD، بين 0.99 و 99.99)',
  sale_blurb_prompt: 'وصف بيع قصير:', purchased_badge: '(تم الشراء)',
  landing_get_started: 'ابدأ', landing_install_app: 'تثبيت التطبيق',
  landing_hero_subtitle: 'أول كتاب لعب ذكي مصمم لمدربي كرة السلة. صمم وحاكِ وشارك الخطط بالذكاء.',
  landing_feature_editor: 'محرر بصري', landing_feature_editor_desc: 'ارسم خططًا لمسية بالإصبع أو القلم. حركات تلقائية.',
  landing_feature_ai: 'مدرب الذكاء', landing_feature_ai_desc: 'ولّد خططًا، أوصِ ضد أي دفاع، توقّع النجاح.',
  landing_feature_share: 'مشاركة سهلة', landing_feature_share_desc: 'صدّر PDF وشارك عبر واتساب بحركات حقيقية.',
  landing_install_short: 'تثبيت',
  landing_hero_h1_a: 'مستقبل كتيبات', landing_hero_h1_b: 'كرة السلة',
  landing_hero_para: '100 خطة احترافية، محرر بصري بصور حقيقية، ذكاء توليدي وتنبؤي، نظام قائمة ودعوات. كل ذلك في منظومة واحدة للمدربين واللاعبين والأكاديميات.',
  landing_stat_plays: 'خطط', landing_stat_languages: 'لغات', landing_stat_coach_24: 'مدرب 24/7',
  landing_live_preview: 'معاينة مباشرة',
  landing_cap_eyebrow: 'القدرات',
  landing_cap_h1_a: 'منظومة كاملة', landing_cap_h1_b: 'لكرة السلة النخبة',
  landing_f_playbook_t: 'كتاب خطط عالمي', landing_f_playbook_d: '100 خطة احترافية مصنفة حسب رجل، منطقة، ATO، BLOB، SLOB ونهاية المباراة، مع حركة خطوة بخطوة.',
  landing_f_ai_t: 'مدرب الذكاء', landing_f_ai_d: 'يولد خططًا جديدة، يحسّن الموجودة، ويتوقع احتمال النجاح. يوصي في المباراة المباشرة.',
  landing_f_roster_t: 'قائمة بالصور', landing_f_roster_d: 'ارفع صورًا حقيقية وأنشئ ملفات لاعبين. اسحب لاعبيك إلى الملعب لخطط تعليمية 100%.',
  landing_f_langs_t: '6 لغات', landing_f_langs_d: 'الإسبانية، الإنجليزية، الفرنسية، البرتغالية، الماندرين والعربية — مع دعم RTL كامل.',
  landing_f_live_t: 'وضع المباراة', landing_f_live_d: 'اختر دفاع الخصم واللحظة؛ يوصي الذكاء بـ 3 خطط فورية مع تبرير تكتيكي.',
  landing_f_editor_t: 'محرر بصري', landing_f_editor_d: 'ملعب NBA، أدوات عائمة، رسم الحركات، شاشات، قطع وخطوات متعددة.',
  landing_cta_h1: 'هل أنت مستعد لإحداث ثورة في لوحتك؟', landing_cta_demo: 'مدرب تجريبي:',
  landing_cta_btn: 'ابدأ مجانًا', contact: 'تواصل',
  achievements_eyebrow: 'الإنجازات', achievements_h1: 'إنجازاتي',
  achievements_subtitle_a: 'افتح الشارات باستخدام التطبيق.', achievements_subtitle_b: 'مفتوحة.',
  achievements_progress: 'التقدم', achievements_latest: 'أحدث الإنجازات المفتوحة',
  achievements_no_data: 'لا توجد بيانات.', achievements_no_yet: 'ابدأ باستخدام التطبيق!',
  cat_creation: 'إنشاء', cat_roster_t: 'القائمة', cat_sales: 'متجر (بائع)',
  cat_buying: 'متجر (مشتري)', cat_quality: 'الجودة', cat_status: 'الحالة', cat_ai: 'الذكاء',
  tier_bronze: 'برونزي', tier_silver: 'فضي', tier_gold: 'ذهبي', tier_elite: 'نخبة',
  no_badges_yet: 'لا توجد إنجازات بعد.',
  notifications_eyebrow: 'الإشعارات', notifications_h1: 'مركز الإشعارات',
  notif_enable_push: 'تفعيل الإشعارات', notif_test: 'اختبار', notif_disable_push: 'تعطيل الإشعارات',
  notif_mark_all: 'تعليم الكل', notif_empty: 'لا توجد إشعارات بعد.',
  notif_marked_all: 'تم تعليم الكل كمقروء',
  notif_push_on: 'تم تفعيل الإشعارات. سنخبرك حتى لو أغلقت التطبيق.',
  notif_push_off: 'تم تعطيل الإشعارات', notif_push_error: 'تعذّر التفعيل',
  notif_test_sent: 'تم إرسال إشعار تجريبي', notif_test_error: 'خطأ في إرسال الاختبار',
  devices: 'جهاز', devices_plural: 'أجهزة',
  market_h1: 'كتيبات النخبة',
  market_subtitle: 'اشترِ خططًا من مدربين موثّقين. كل عملية شراء تُنسخ إلى كتيبك الخاص.',
  market_publish_my_play: 'انشر خطتي',
  market_publish_my_play_title: 'انشر خطتك في المتجر',
  market_banner_title: 'هل أنت مدرب؟ شارك وبِع نظامك',
  market_banner_body: 'انشر خططك مع الحركة والمسارات والسرعات. حدد السعر بين 0.99$ و 99.99$. تحتفظ بـ 85% من كل عملية بيع.',
  market_banner_start: 'ابدأ ←',
  market_tab_listings: 'خطط للبيع',
  market_tab_coaches: 'مدربو النخبة',
  market_tab_leaderboard: 'الترتيب · مدرب الشهر',
  market_sort_popular: 'الأكثر شعبية',
  market_sort_recent: 'الأحدث',
  market_sort_price_asc: 'السعر ↑',
  market_sort_price_desc: 'السعر ↓',
  market_cat_all: 'الكل',
  market_empty: 'لا توجد خطط للبيع في هذه الفئة بعد.',
  market_sales: 'مبيعات',
  market_success: 'نجاح',
  market_students: 'طلاب',
  market_plays_count: 'خطط',
  market_verified_elite: 'نخبة موثّقة',
  roster_h1: 'القائمة',
  roster_player_updated: 'تم تحديث اللاعب',
  roster_player_added: 'تم إضافة اللاعب',
  roster_save_error: 'خطأ في الحفظ',
  roster_delete_confirm: 'حذف اللاعب؟ (سيُحذف من الفريق نهائيًا.)',
  roster_block_confirm: 'حظر هذا اللاعب؟ لن يكون من الفريق ولن يرى خططك.',
  roster_unblock_confirm: 'إلغاء حظر اللاعب؟ سيعود إلى رؤية خططك.',
  roster_player_unblocked: 'تم إلغاء حظر اللاعب',
  roster_player_blocked: 'تم حظر اللاعب',
  roster_action_error: 'فشل الإجراء',
  roster_no_players: 'لا يوجد لاعبون بعد. اضغط',
  roster_camera_title: 'التقط صورة بالكاميرا',
  roster_upload_gallery_title: 'رفع من المعرض',
  roster_camera_btn: 'كاميرا',
  roster_upload_btn: 'رفع',
  roster_photo_uploaded: 'تم رفع الصورة',
  roster_photo_upload_error: 'خطأ في رفع الصورة',
  roster_blocked_badge: 'محظور',
  roster_block_btn: 'حظر',
  roster_unblock_btn: 'إعادة تفعيل',
  roster_delete_title: 'حذف نهائي',
  roster_block_title: 'حظر وإخراج من الفريق',
  roster_unblock_title: 'إلغاء الحظر',
  roster_no_photo: 'بدون صورة',
  roster_hand_right: 'يمنى',
  roster_hand_left: 'يسرى',
  roster_hand_ambi: 'كلتاهما',
  roster_hand_letter_right: 'ي',
  roster_hand_letter_left: 'ش',
  roster_hand_letter_ambi: 'ك',
  roster_player_in_court: 'موجود بالفعل في الملعب',
  roster_player_added_to_court: 'تمت الإضافة',
  admin_h1: 'لوحة المسؤول',
  admin_tab_overview: 'النظرة العامة',
  admin_tab_users: 'المستخدمون',
  admin_tab_activity: 'النشاط',
  admin_coaches: 'المدربون',
  admin_players: 'اللاعبون',
  admin_plays_global: 'خطط عالمية',
  admin_ai_sessions: 'جلسات الذكاء',
  admin_top_plays: 'أفضل الخطط',
  admin_by_category: 'حسب الفئة',
  admin_col_name: 'الاسم',
  admin_col_email: 'البريد',
  admin_col_role: 'الدور',
  admin_col_created: 'تاريخ الإنشاء',
  admin_delete_user_confirm: 'حذف المستخدم؟',
  admin_recent_activity: 'النشاط الأخير',
  sim_back_to_play: 'العودة إلى الخطة',
  sim_eyebrow: 'محاكي تكتيكي',
  sim_subtitle: 'سيحاكي الذكاء كيف سيتفاعل الدفاع ويقترح تعديلات ملموسة.',
  sim_rival_defense: 'دفاع الخصم',
  sim_exec_level: 'مستوى التنفيذ',
  sim_run_now: 'محاكاة الآن',
  sim_running: 'جارٍ المحاكاة...',
  sim_ai_prediction: 'توقع الذكاء',
  sim_confidence: 'الثقة:',
  sim_def_reaction: 'كيف يتفاعل الدفاع',
  sim_failure_points: 'مواطن الفشل',
  sim_adjustments: 'تعديلات موصى بها',
  sim_key_player: 'اللاعب #1:',
  tpl_modal_eyebrow: 'القوالب',
  tpl_modal_title: 'ابدأ بنظام مُجرّب',
  tpl_modal_subtitle: 'خطط محملة مسبقًا بسرعات وتأخيرات مُعايرة. عدّلها على ذوقك.',
  tpl_steps_count: 'خطوات',
  diff_basic: 'مبتدئ',
  diff_medium: 'متوسط',
  diff_advanced: 'متقدم',
  editor_add_defenders: 'إضافة مدافعين',
  editor_add_defenders_title: 'ضع 5 مدافعين في تشكيل رجل-لرجل',
  editor_defenders_added: 'تمت إضافة 5 مدافعين',
  editor_defenders_already: 'المدافعون موجودون بالفعل',
  editor_remove_defenders: 'إزالة الدفاع',
  editor_remove_defenders_title: 'إزالة المدافعين الخمسة من هذه الخطوة',
  editor_defenders_removed: 'تمت إزالة الدفاع',
  enrich_play: '✨ إثراء السرد',
  regenerate_enrichment: '✨ إعادة توليد السرد',
  enriching: 'جارٍ الإثراء...',
  enrichment_success: 'تم إثراء الخطة — الصوت والنصوص أصبحت أكثر تعليمية',
  enrichment_error: 'خطأ في إثراء الخطة',
  enrichment_hint: 'يولّد الذكاء شرحًا أطول وأكثر تعليمية (ماذا + لماذا + الإشارة الأساسية) لكل خطوة. سيقرأ السرد النص المُثرى.',
  bulk_enrich_section_title: 'إثراء جماعي',
  bulk_enrich_section_body: 'أثرِ جميع خططك دفعة واحدة باللغة الحالية. يولّد الذكاء سرودًا تعليمية (ماذا + لماذا + إشارة أساسية) يسمعها لاعبوك. يعمل في الخلفية — يمكنك إغلاق هذه النافذة، يتم الحفاظ على التقدم.',
  bulk_enrich_btn: '🚀 إثراء جميع خططي',
  bulk_enrich_running: 'جارٍ الإثراء',
  bulk_enrich_hint: 'يولّد سرودًا مثراة لجميع خططك باللغة الحالية.',
  bulk_enrich_force_label: 'إعادة التوليد بالقوة (حتى المُثراة بالفعل)',
  bulk_enrich_in_progress: 'جارٍ إثراء الخطط',
  bulk_enrich_done: 'اكتمل الإثراء!',
  bulk_enrich_done_title: 'انتهى',
  bulk_enrich_start_error: 'تعذّر بدء الإثراء',
  bulk_enrich_completed: 'مكتملة',
  bulk_enrich_skipped: 'تم تخطيها (مُثراة بالفعل)',
  bulk_enrich_failed: 'فاشلة',
  bulk_enrich_current: 'تتم المعالجة الآن',
  bulk_enrich_errors: 'أخطاء',
  bulk_enrich_background_note: 'قد يستغرق هذا عدة دقائق حسب عدد الخطط. يمكنك إغلاق هذه النافذة — العملية تستمر في الخلفية.',
};

export default dict;
